import { type DependencyList, useRef } from 'react';
import isEqual from 'react-fast-compare';
import type { DepsCache } from './types';

const useStableMemo = <T>(factory: () => T, deps?: DependencyList): T => {
  let isValid = true;

  const valueRef = useRef<DepsCache<T>>();

  if (!valueRef.current) {
    valueRef.current = {
      deps,
      result: factory()
    };
  } else {
    isValid = !!(deps && valueRef.current.deps && isEqual(deps, valueRef.current.deps));
  }

  const cache = isValid ? valueRef.current : { deps, result: factory() };

  valueRef.current = cache;

  return cache.result;
};

export default useStableMemo;
